"use strict";

define('uikit/elements/dropdown',['require','exports','module','underscore','backbone','marionette','../channel','../helper/browser','../mixins/component.mixin','../templates','../extra/size','../extra/color','../extra/floated','handlebars','semantic.dropdown','semantic/modules/transition'],function (require, exports, module) {
  var _ = require('underscore');
  var Backbone = require('backbone');
  var Mn = require('marionette');
  var channel = require('../channel');
  var browser = require('../helper/browser');
  var ComponentMixin = require('../mixins/component.mixin');
  var Templates = require('../templates');
  var Size = require('../extra/size');
  var Color = require('../extra/color');
  var Floated = require('../extra/floated');
  var Handlebars = require('handlebars');
  require('semantic.dropdown');
  require('semantic/modules/transition');
  var BUTTON_MODE = 'button';
  var SELECT_MODE = 'select';
  var DropDownItemView = Mn.CompositeView.extend(ComponentMixin).extend({
    tagName: 'li',
    className: "item",
    attributes: {
      role: 'option'
    },
    allowTagChange: true,
    options: {
      text: '',
      color: '',
      description: '',
      disabled: '',
      icon: '',
      link: '',
      target: '',
      menuDirection: 'right',
      fluid: false,
      value: null,
      isButton: false
    },
    update: {
      fluid: false,
      value: false
    },
    childView: DropDownItemView,
    handleNewSelectedItem: function handleNewSelectedItem() {
      var dropdownView = this.getOption('dropdownView');
      dropdownView._setARIASelectedAttribute(this);
      dropdownView._setARIAActiveDecendantAttribute(this);
    },
    onFirstRender: function onFirstRender() {
      var dropdownView = this.getOption('dropdownView'),
        self = this;
      var observer = new MutationObserver(function (mutations) {
        if (mutations[0].target.classList.contains('selected')) {
          self.handleNewSelectedItem();
        }
      });
      observer.observe(this.el, {
        attributes: true,
        attributeFilter: ['class']
      });
      if (this.collection instanceof Backbone.Collection) {
        this.listenTo(this.collection, 'add remove reset', _.debounce(function () {
          var value = dropdownView.getValueForDropdown(this.value);
          dropdownView._updateValue(value, this);
        }, 1));
      }
      this.on('change:value', _.debounce(function () {
        var value = dropdownView.getValueForDropdown(this.value);
        dropdownView._updateValue(value, this);
      }, 1), this);
      if (this.value) {
        _.defer(function () {
          var value = dropdownView.getValueForDropdown(self.value);
          dropdownView._updateValue(value, self);
        });
      }
    },
    childViewContainer: ' > .menu',
    onBeforeAddChild: function onBeforeAddChild(childView) {
      childView.dropdownView = this.getOption('dropdownView');
      childView.collection = childView.bindings.get('collection');
      childView.index = this.collection.indexOf(childView.model);
    },
    updateAttributes: function updateAttributes() {
      this.$el.attr('data-value', this.getOption('dropdownView')._getModelId(this.model));
      var itemLink = this.bindings.get('link');
      var attrs = {
        tabindex: '-1'
      };
      if (itemLink) {
        attrs = _.extend(attrs, {
          href: itemLink,
          id: this.cid
        });
        attrs = this.model.get('target') ? _.extend(attrs, {
          target: this.model.get('target')
        }) : attrs;
        this.updateElementAttributes(attrs);
      } else {
        this.removeElementAttribute('href');
      }
      if (this.getBoolOption('isButton')) {
        this.updateElementAttributes({
          role: 'button'
        });
        this.updateElementAttributes({
          tabindex: '-1'
        });
      }
      this.addClass('disabled', this.getBoolOption('disabled'));
    },
    serializeData: function serializeData() {
      var data = ComponentMixin.serializeData.apply(this, arguments),
        ddv = this.getOption('dropdownView');
      if (ddv) {
        data.fluid = ddv.getBoolOption('fluid');
      }
      data.hasChildren = this.collection instanceof Backbone.Collection;
      return data;
    },
    template: Templates.UIKit['dropdown.itemview']
  });
  var DropDownHeaderView = Mn.ItemView.extend({
    className: 'header',
    template: function template(data) {
      var str = '';
      if (data.icon) {
        str += '<i class="' + Handlebars.escapeExpression(data.icon) + ' icon"></i> ';
      }
      str += Handlebars.escapeExpression(data.text);
      return str;
    }
  });
  var DropDownDividerView = Mn.ItemView.extend({
    className: 'divider',
    attributes: {
      role: 'separator'
    },
    template: false
  });
  var DropDownHeaderModel = Backbone.Model.extend({});
  var DropDownDividerModel = Backbone.Model.extend({});
  var Dropdown = Mn.CompositeView.extend(ComponentMixin).extend({
    className: 'ui dropdown',
    template: Templates.UIKit['dropdown'],
    attributes: {
      'aria-haspopup': 'listbox'
    },
    ui: {
      menu: '> .menu',
      searchInput: '> input.search',
      clearBtn: '> .ui.clear.button'
    },
    options: {
      activation: 'click',
      bindCollectionLoading: false,
      circular: false,
      clearable: false,
      collection: null,
      color: '',
      customFilter: false,
      direction: 'down',
      disabled: false,
      error: false,
      floated: '',
      floating: false,
      fluid: false,
      focusable: true,
      forceSelection: true,
      fullTextSearch: false,
      header: '',
      icon: 'dropdown',
      iconOnly: false,
      iconRight: true,
      inline: false,
      inverted: false,
      labeled: false,
      loading: false,
      mode: 'select',
      placeholder: null,
      pointing: '',
      preserveHTML: true,
      search: false,
      size: '',
      state: null,
      text: null,
      textColor: null,
      useIdAsValue: false,
      value: null,
      visible: true,
      basic: false,
      ariaLabel: null,
      ariaLabelledby: null,
      htmlId: '',
      semanticDropdownOptions: {}
    },
    colorOptionValues: _.values(Color),
    sizeOptionValues: _.values(Size),
    floatedOptionValues: _.values(Floated),
    modeOptionValues: ['select', 'button'],
    update: {
      disabled: false,
      state: false,
      value: false,
      circular: false,
      fullTextSearch: false,
      forceSelection: false,
      preserveHTML: false,
      floating: false,
      size: false,
      inverted: false,
      useIdAsValue: false,
      customFilter: false,
      loading: false,
      bindCollectionLoading: false,
      basic: false,
      ariaLabel: true,
      ariaLabelledby: true,
      htmlId: true
    },
    initialize: function initialize() {
      ComponentMixin.initialize.apply(this, arguments);
      this.htmlId = this.cid;
    },
    events: {
      'mousedown': function mousedown() {
        this._cancelNextFocus = false;
      },
      'mousedown .item': function mousedown_Item(ev) {
        if (this.search) {
          var $item = $(ev.currentTarget),
            className = $.fn.dropdown.settings.className;
          $item.removeClass(className.active);
        }
      },
      'click .item': function click_Item(ev) {
        if (!$.support.transition) {
          this._cancelNextFocus = true;
        }
      },
      'focus': function focus(ev) {
        if (this._cancelNextFocus) {
          this._cancelNextFocus = false;
          ev.stopImmediatePropagation();
          ev.preventDefault();
          return false;
        }
      },
      'keydown': 'handleKeydown',
      'keydown @ui.searchInput': function keydown_UiSearchInput(ev) {
        var keyCode = ev.which || ev.keyCode,
          $search = this.$('> input.search'),
          self = this;
        if (keyCode == 13) {
          this._startingSearchInput = false;
          this.triggerMethod('search:enter', $search.val(), ev);
        } else if (keyCode == 27) {
          this._startingSearchInput = false;
          this.$el.dropdown('clear');
          this.$el.dropdown('hide');
        } else {
          _.defer(function () {
            var value = $search.val();
            if (value !== self._searchValue) {
              self._searchValue = value;
              self.triggerMethod('search:value', $search.val(), ev);
            }
          });
        }
      },
      'blur @ui.searchInput': function blur_UiSearchInput(ev) {
        if (this._startingSearchInput) {
          var val = this.$('> input.search').val();
          this.triggerMethod('search:blur', val, ev);
          this._startingSearchInput = false;
        }
      },
      'focus @ui.searchInput': function focus_UiSearchInput() {
        if (this._startingSearchInput !== true) {
          this._startingSearchInput = true;
          this._searchValue = this.ui.searchInput.val();
          this.triggerMethod('search:start');
        }
        this.triggerMethod('search:focus');
      },
      'click > .ui.clear.button': 'onClearBtnClick',
      'click .menu .item': 'onItemClick',
      'keydown > .ui.clear.button': 'onClearBtnKeyDown'
    },
    handleKeydown: function handleKeydown(ev) {
      switch (ev.keyCode) {
        case 32:
          ev.preventDefault();
          if ($(ev.target).hasClass("dropdown")) {
            $(ev.target).click();
          } else {
            var _selectedItem = this.$el.find('> .menu .item.selected');
            this.triggerItemPress(_selectedItem);
          }
          break;
        case 13:
          var selectedItem = this.$el.find('> .menu .item.selected');
          this.triggerItemPress(selectedItem);
          break;
        case 27:
          this.handleEscapeKeyPress(ev);
          break;
        case 35:
        case 36:
          this.handleHomeEndKeyPress(ev);
          break;
      }
    },
    childViewContainer: ' > .menu',
    getChildView: function getChildView(model) {
      if (model instanceof DropDownHeaderModel) {
        return DropDownHeaderView;
      } else if (model instanceof DropDownDividerModel) {
        return DropDownDividerView;
      }
      return DropDownItemView;
    },
    childViewOptions: function childViewOptions() {
      return {
        dropdownView: this
      };
    },
    _getPropertyForModel: function _getPropertyForModel(model, property) {
      return this.getPropertyForModel && this.getPropertyForModel(model, property) || model.get(this.getOption(property + "Field"));
    },
    onSearchEnter: function onSearchEnter(searchValue, ev) {
      this.checkItemAdd(searchValue, ev);
    },
    onSearchBlur: function onSearchBlur(searchValue, ev) {
      if (searchValue) {
        this.checkItemAdd(searchValue, ev);
      }
    },
    checkItemAdd: function checkItemAdd(searchValue, ev) {
      var className = $.fn.dropdown.settings.className,
        selector = $.fn.dropdown.settings.selector,
        $currentlySelected = this.$(selector.menu + ' ' + selector.item + '.' + className.selected).not('.' + className.filtered).eq(0);
      if ($currentlySelected.length == 0) {
        this.triggerMethod('item:add', searchValue, ev);
      }
    },
    onChangeCollection: function onChangeCollection() {
      if (!this.collection) {
        return;
      }
      if (this._firstRender) {
        this.listenTo(this.collection, 'add remove reset', _.debounce(function () {
          var dropdownModule = this.$el.data('moduleDropdown');
          if (!dropdownModule || !dropdownModule.is.active()) {
            var value = this.getValueForDropdown(this.value);
            this._updateValue(value, this);
          }
        }, 1));
        if (this.bindCollectionLoading) {
          this.listenTo(this.collection, 'request', function () {
            this.loading = true;
          }).listenTo(this.collection, 'sync error', function () {
            this.loading = false;
          });
        }
      }
    },
    onFirstRender: function onFirstRender() {
      this._firstRender = true;
      if (!('MutationObserver' in window)) {
        this.on('add:child remove:child', function () {
          this.$el.dropdown('refresh');
        }, this);
      }
      this.on('change:value', _.debounce(function () {
        var value = this.getValueForDropdown(this.value);
        this._updateValue(value, this);
      }, 1), this);
    },
    onRender: function onRender() {
      var action,
        self = this,
        noResults = false;
      var semanticDropdownOptions = this.getOption('semanticDropdownOptions');
      if (!this.getBoolOption('focusable')) {
        this.$el.removeAttr('tabindex');
      }
      if (this._isRendered) {
        this.$el.dropdown('clear');
      } else {
        this.updateAttributes();
      }
      if (this.getOption('mode') == 'button') {
        action = 'hide';
      } else {
        if (this.getOption('text')) {
          action = 'select';
        } else {
          action = 'activate';
        }
      }
      this.$el.removeClass('visible').dropdown(_.extend({
        transition: browser.isIE() == '9' ? 'slide down' : 'auto',
        action: action,
        on: this.getOption('activation'),
        fullTextSearch: this.fullTextSearch,
        forceSelection: this.forceSelection,
        preserveHTML: this.preserveHTML,
        metadata: {
          defaultText: this.placeholder,
          defaultValue: null
        },
        onChange: function onChange() {
          self._onDropdownChange.apply(self, arguments);
        },
        onNoResults: function onNoResults() {
          noResults = true;
        },
        onShow: function onShow() {
          if (!$.support.transition) {
            self.$('> .menu').transition('set visible');
          }
          self.triggerMethod('dropdown:show');
        },
        onHide: function onHide() {
          if (self.getOption('mode') === 'button') {
            $(self.el).find("ul").removeAttr("aria-activedescendant");
            $(self.el).find("ul .item").each(function (index, item) {
              $(item).removeClass("selected");
              $(item).removeAttr("aria-selected");
            });
          }
          if (self.search === true) {
            _.defer(function () {
              if (noResults) {
                noResults = false;
              }
            });
          }
          var $menu = self.$('> .menu'),
            transitionModule = $menu.data().moduleTransition;
          if (transitionModule && $.support.transition && transitionModule.is.animating()) {
            $menu.one(transitionModule.get.animationEndEvent(), function () {
              $menu.transition('remove visible').transition('remove hidden');
            });
          } else {
            $menu.transition('remove visible').transition('remove hidden');
          }
          self.triggerMethod('dropdown:hide');
        }
      }, semanticDropdownOptions));
      var dropdownModule = this.$el.data('moduleDropdown');
      if (dropdownModule) {
        dropdownModule.focusSearch = function () {};
      }
      if (dropdownModule && this.customFilter) {
        dropdownModule.filter = _.bind(function (searchTerm) {
          this._customDropdownFilter(searchTerm, dropdownModule);
        }, this);
        this.on('search:start', function () {
          if (dropdownModule.can.show()) {
            dropdownModule.show();
          }
        });
        if (this.collection) {
          this.listenTo(this.collection, 'add remove reset', _.debounce(function () {
            var item = this.children.first();
            if (dropdownModule.is.active() && item) {
              dropdownModule.remove.selectedItem();
              var className = $.fn.dropdown.settings.className;
              item.$el.addClass(className.selected);
            }
          }));
        }
      }
      var value = this.getValueForDropdown(this.value);
      this._updateValue(value, this);
    },
    _customDropdownFilter: function _customDropdownFilter(searchTerm, module) {
      if (module.can.show()) {
        module.show();
      }
    },
    onBeforeAddChild: function onBeforeAddChild(childView) {
      childView.collection = this._getPropertyForModel(childView.model, 'collection');
      childView.collection = childView.bindings.get('collection');
      childView.index = this.collection.indexOf(childView.model);
    },
    isComboBox: function isComboBox() {
      return this.getBoolOption('search');
    },
    setComboBoxAttributes: function setComboBoxAttributes() {
      var self = this;
      this.updateElementAttributes({
        role: 'combobox',
        'aria-owns': this.cid + 'Menu'
      });
      this.on('render', function () {
        self.$el.find('.search').attr({
          'aria-controls': self.cid + 'Menu',
          'aria-autocomplete': 'list',
          'aria-expanded': 'false'
        });
      });
    },
    isMenuItem: function isMenuItem() {
      return this._parent && this._parent.el.classList.contains('product-header') || this.el.parentElement && ['menu', 'menubar'].includes(this.el.parentElement.getAttribute('role'));
    },
    setListBoxAttributes: function setListBoxAttributes(role) {
      this.updateElementAttributes({
        tabindex: '0',
        role: role,
        'aria-controls': this.cid + 'Menu',
        'aria-expanded': 'false'
      });
    },
    setAriaLabelling: function setAriaLabelling() {
      var self = this;
      var $targetView = this.isComboBox() ? this.$el.find('.search') : this.$el;
      var toggleLabelling = function toggleLabelling($targetView, ariaProperty, ariaAttribute) {
        if (self.getBoolOption(ariaProperty)) {
          $targetView.attr(ariaAttribute, self.getOption(ariaProperty));
        } else {
          $targetView.removeAttr(ariaAttribute);
        }
      };
      toggleLabelling($targetView, 'ariaLabel', 'aria-label');
      toggleLabelling($targetView, 'ariaLabelledby', 'aria-ariaLabelledby');
    },
    updateAriaAttributes: function updateAriaAttributes() {
      if (this.isComboBox()) {
        this.setComboBoxAttributes();
      } else {
        this.setListBoxAttributes(this.isMenuItem() ? 'menuitem' : 'button');
      }
      this.setAriaLabelling();
      this.updateAriaDisabledAttribute();
      return this;
    },
    updateAttributes: function updateAttributes() {
      this.ui.menu.attr('tabindex', '-1');
      this.addClass('clearable', this.getBoolOption('clearable')).addClass(this.getOption('color'), this.getBoolOption('color')).addClass(this.getOption('floated') + ' floated', this.getBoolOption('floated') && this.getOption('mode') == 'button').addClass('floating', this.getBoolOption('floating')).addClass('upward', this.getOption('direction') == 'up').addClass("search", this.getBoolOption("search")).addClass('fluid', this.getBoolOption('fluid')).addClass(this.getOption('pointing') + ' pointing', this.getBoolOption('pointing')).addClass('icon', this.getBoolOption('icon') && this.getOption('icon') != 'dropdown' && !this.getBoolOption('text')).addClass("selection", this.getOption("mode") == "select" && !this.getBoolOption('inline')).addClass('labeled', this.getBoolOption('labeled')).addClass("button", this.getOption("mode") == "button" && !this.getBoolOption('inline')).addClass("inline", this.getBoolOption('inline')).addClass('error', this.getBoolOption('error')).addClass(this.getOption('state'), this.getBoolOption('state')).addClass('disabled', this.getBoolOption('disabled')).addClass('circular', this.getBoolOption('circular')).addClass(this.getOption('size'), this.getBoolOption('size')).addClass('inverted', this.getBoolOption('inverted')).addClass('loading', this.getBoolOption('loading')).addClass('basic', this.getBoolOption('basic')).updateAriaAttributes();
    },
    getValueModelForModel: function getValueModelForModel(value) {
      if (this.getOption('modelValue')) {
        value = Mn._getValue(this.getOption('modelValue'), this, [value, this.collection, this.model]);
      } else if (this.useIdAsValue) {
        var model = this.collection.get(value);
        return model ? model.id : null;
      }
      return value;
    },
    getValueForDropdown: function getValueForDropdown(value) {
      if (this.getOption('dropdownValue')) {
        value = Mn._getValue(this.getOption('dropdownValue'), this, [value, this.collection, this.model]);
      } else if (this.useIdAsValue) {
        return this.collection.get(value);
      }
      return value;
    },
    _updateValue: function _updateValue(value, view) {
      if (value && this.getOption('mode') == 'button') {
        if (this.getOption('text')) {
          this.$el.dropdown('set value', this._getModelId(value));
        } else {
          this.$el.dropdown('set selected', this._getModelId(value));
        }
      } else if (value) {
        this.$el.dropdown('set selected', this._getModelId(value));
        if (this.getOption('clearable')) {
          this.ui.clearBtn.show();
        } else {
          this.ui.clearBtn.hide();
        }
      } else {
        var $el = this.$el;
        this.ui.clearBtn.hide();
        if (this.getOption('mode') == 'select') {
          $el.dropdown('clear');
        } else {
          $el.dropdown('set value', '').dropdown('remove activeItem').dropdown('remove selectedItem');
        }
        _.defer(function () {
          $el.blur();
        });
      }
    },
    findItemByModel: function findItemByModel(model) {
      return this.$('.item[data-value="' + this._getModelId(model) + '"]');
    },
    _getModelId: function _getModelId(model) {
      if (!model) {
        return null;
      }
      return model.id == null ? model.cid : model.id;
    },
    _getModelById: function _getModelById(id, collection) {
      collection = collection || this.collection;
      var models = collection ? collection.models : [],
        model = null;
      for (var i = 0, len = models.length, m; i < len; i++) {
        m = models[i];
        if (this._getModelId(m) === id) {
          return m;
        }
        if (this._getPropertyForModel(m, 'collection')) {
          model = this._getModelById(id, this._getPropertyForModel(m, 'collection'));
        }
        if (model) {
          return model;
        }
      }
      return model;
    },
    _setARIASelectedAttribute: function _setARIASelectedAttribute(view) {
      this.ui.menu.find('[aria-selected="true"]').removeAttr('aria-selected');
      view.updateElementAttributes({
        'aria-selected': 'true'
      });
    },
    _setARIAActiveDecendantAttribute: function _setARIAActiveDecendantAttribute(view) {
      var $targetView = this.isComboBox() ? this.$el.find('.search') : this.ui.menu;
      $targetView.attr({
        'aria-activedescendant': view.$el.attr('id')
      });
    },
    _onDropdownChange: function _onDropdownChange(id, text, $choice) {
      var model = this._getModelById(id);
      if (this.getBoolOption('textColor')) {
        this.$('> .text').addClass(this.getOption('textColor'));
      }
      var $search = this.$('> input.search');
      if (document.activeElement === $search.get(0)) {
        _.defer(function () {
          $search.blur();
        });
      }
      var view = _.find(this._getNestedViews(), function (view) {
        return view.el === $choice.get(0);
      });
      if (view) {
        view._parent._internal.value = this.getValueModelForModel(view.model);
        this.triggerMethod('item:select', view, view.model);
      } else {
        this._internal.value = void 0;
      }
    },
    onDropdownShow: function onDropdownShow() {
      var $focusTarget = this.isComboBox() ? this.$el.find('.search') : this.ui.menu;
      var $attrTarget = this.isComboBox() ? this.$el.find('.search') : this.$el;
      $attrTarget.attr({
        'aria-expanded': 'true'
      });
      $focusTarget.focus();
    },
    onDropdownHide: function onDropdownHide() {
      var $attrTarget = this.isComboBox() ? this.$el.find('.search') : this.$el;
      $attrTarget.attr({
        'aria-expanded': 'false'
      });
    },
    handleEscapeKeyPress: function handleEscapeKeyPress(ev) {
      ev.preventDefault();
      this.$el.dropdown('hide');
      this.focus();
    },
    handleHomeEndKeyPress: function handleHomeEndKeyPress(ev) {
      var semanticDropdownModule = this.$el.data('moduleDropdown');
      var $nextItem = ev.keyCode === 35 ? this.ui.menu.find('.item').last() : this.ui.menu.find('.item').first();
      var $currentItem = this.ui.menu.find('.item.selected');
      ev.preventDefault();
      $currentItem.removeClass('selected');
      $nextItem.addClass('selected');
      semanticDropdownModule.set.scrollPosition($nextItem);
    },
    blur: function blur() {
      this.$el.dropdown('remove searchTerm');
      this.$el.blur();
    },
    focus: function focus() {
      this.$el.focus();
    },
    onClearBtnClick: function onClearBtnClick(ev) {
      ev.stopPropagation();
      this.value = null;
    },
    onClearBtnKeyDown: function onClearBtnKeyDown(ev) {
      if (ev.keyCode === 13) {
        ev.stopPropagation();
        this.value = null;
      }
    },
    triggerItemPress: function triggerItemPress(itemEl) {
      if (this.getOption('mode') != BUTTON_MODE) {
        return;
      }
      var id = $(itemEl).data('value'),
        model = this._getModelById(id);
      if (model) {
        this.triggerMethod('press', model);
      }
    },
    onItemClick: function onItemClick(ev) {
      this.triggerItemPress(ev.currentTarget);
    }
  }, {
    _prepareDropdownModel: function _prepareDropdownModel(obj) {
      var modelType = String(obj.model || '');
      delete obj.model;
      if (modelType == 'header') {
        return new DropDownHeaderModel(obj);
      } else if (modelType == 'divider') {
        return new DropDownDividerModel(obj);
      } else {
        return new Backbone.Model(obj);
      }
    },
    createCollection: function createCollection(items) {
      var model = null,
        collection = new Backbone.Collection([]);
      if (!_.isArray(items)) {
        return collection;
      }
      for (var i = 0, len = items.length; i < len; i++) {
        model = this._prepareDropdownModel(items[i]);
        collection.push(model);
      }
      return collection;
    },
    addHeaderToCollection: function addHeaderToCollection(def, collection, index) {
      var header = new DropDownHeaderModel(def || {});
      index = index != null ? index : collection.length;
      collection.add(header, {
        at: index
      });
      return this;
    },
    addDividerToCollection: function addDividerToCollection(collection, index) {
      var divider = new DropDownDividerModel();
      index = index != null ? index : collection.length;
      collection.add(divider, {
        at: index
      });
      return this;
    }
  });
  channel.reply('dropdown', function () {
    return Dropdown;
  });
  Dropdown.ItemView = DropDownItemView;
  Dropdown.HeaderModel = DropDownHeaderModel;
  Dropdown.DividerModel = DropDownDividerModel;
  Dropdown.BUTTON_MODE = BUTTON_MODE;
  Dropdown.SELECT_MODE = SELECT_MODE;
  module.exports = Dropdown;
});

